import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { nextTick, ref } from "vue";
import { SCROLL_SKEW_ANIMATION_MAX_ITEMS } from "@/util/constants.ts";

export default function useScrollSkewAnimation(
  containerSelector,
  itemSelector
) {
  const skewProxy = ref({ skew: 0 });

  const clamp = gsap.utils.clamp(-10, 10);

  const isReducedMotion =
    window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
    window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

  gsap.registerPlugin(ScrollTrigger);

  function destroy() {
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  }

  async function reload() {
    if (isReducedMotion) {
      return;
    }

    destroy();

    await nextTick();

    const containerElement = document.querySelector(containerSelector);
    const itemElements = document.querySelectorAll(itemSelector);

    if (
      !containerElement ||
      !itemElements.length ||
      itemElements.length >= SCROLL_SKEW_ANIMATION_MAX_ITEMS
    ) {
      return;
    }

    const skewSetter = gsap.quickSetter(itemSelector, "skewY", "deg");

    ScrollTrigger.create({
      scroller: containerElement,
      trigger: itemSelector,
      end: containerElement.scrollHeight,
      onUpdate: (self) => {
        const skew = clamp(self.getVelocity() / -200);

        if (Math.abs(skew) > Math.abs(skewProxy.value.skew)) {
          skewProxy.value.skew = skew;

          gsap.to(skewProxy.value, {
            skew: 0,
            duration: 0.3,
            ease: "expo",
            overwrite: true,
            onUpdate: () => skewSetter(skewProxy.value.skew),
          });
        }
      },
    });

    gsap.set(itemSelector, {
      transformOrigin: "right center",
      force3D: true,
    });

    ScrollTrigger.refresh();
  }

  reload();

  return {
    reload,
    destroy,
  };
}
